import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { MainSliderComponent } from './home/main-slider/main-slider.component';
import { AboutUsComponent } from './home/about-us/about-us.component';
import { OurServicesComponent } from './home/our-services/our-services.component';
import { SocialComponent } from './home/social/social.component';
import { LicencesComponent } from './home/licences/licences.component';
import { FooterComponent } from './footer/footer.component';
import { DrmeBlogModule } from './_modules/drme-blog/drme-blog.module';
import { DrmeMainPageComponent } from './home/drme-main-page/drme-main-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    MainSliderComponent,
    AboutUsComponent,
    OurServicesComponent,
    SocialComponent,
    LicencesComponent,
    FooterComponent,
    DrmeMainPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DrmeBlogModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
